import { Typography } from '@mui/material';
import Box from '@mui/material/Box/Box';
import React from 'react';
import RequestHeaders from './RequestHeaders';
import RequestBody from './RequestBody';
import { useFormContext } from 'react-hook-form';
import OutputExtractors from './OutputExtractors';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: string;
  handleContextMenu: (event: React.MouseEvent, filedName: any, inputRef) => void;
}
const TabContainer = (props: TabPanelProps) => {
  const { children, value, index,handleContextMenu, ...other } = props;

  return (
    <div
      role="tabpanel"
      //   hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === 'headers' && (
        <Box sx={{ pt:1, pr:1 }}>
          <RequestHeaders handleContextMenu={(e, filedName, inputRef) => handleContextMenu(e, filedName, inputRef)}/>
        </Box>
      )}
      {value === 'body' && (
        <Box sx={{ pt:1, pr:1 }}>
          <RequestBody handleContextMenu={(e, filedName, inputRef) => handleContextMenu(e, filedName, inputRef)}/>
        </Box>
      )}
      {value === 'output' && (
        <Box sx={{ pt:1, pr:1 }}>
          <OutputExtractors />
        </Box>
      )}
    </div>
  );
};

export default TabContainer;
